import makeStyles from "@mui/styles/makeStyles";

export default makeStyles(
  (theme) => ({
    root: {
      margin: "auto",
    },
    center: {
      margin: 0,
      padding: 0,
    },
    grid: {
      display: "flex",
      marginBottom: 40,
    },
    centerGrid: {
      justifyContent: "center",
    },
    lazyLoadWrapper: {
      height: "100%",
    },
    contentScroll: {
      display: "flex",
      flexDirection: "row",
      flexWrap: "nowrap",
      alignItems: "center",
      justifyContent: "start",
      overflow: "auto",
      padding: [15, 0, 20],
      [theme.breakpoints.up("mobile")]: {
        padding: [30, 0],
      },
      [theme.breakpoints.up("tablet")]: {
        padding: [30, 0, 60],
      },
    },
    itemScrolleable: {
      width: "38%",
      minWidth: "38%",
      margin: 10,
      padding: "0!important",
      [theme.breakpoints.up("mobile")]: {
        width: "21%",
        minWidth: "21%",
      },
      [theme.breakpoints.up("tablet")]: {
        width: 190,
        minWidth: 190,
      },
    },
    title: {
      textAlign: "center",
      marginBottom: 8,
      [theme.breakpoints.up("tablet")]: {
        textAlign: "left",
        marginBottom: 28,
      },
    },
    centerTitle: {
      textAlign: "center",
      margin: 0,
    },
  }),
  { name: "StarringYouCards" },
);
